export enum Experiment {
  EnableDeleteCardModal = 'spec.payments-checkout.EnableDeleteCardModal',
  /**
   * This is a feature-toggle experiment that allows us to disable
   * "Add new card" functionality for specific msids. Useful to prevent
   * card testing activity. It's a temporary manual solution until captcha
   * will be integrated.
   */
  DisableAddCardInMyWallet = 'spec.payments-checkout.DisableAddCardInMyWallet',
}
